<template>
    <div class="full-cut-detail-wrap">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <h2>{{form.freeName||'新建'}}</h2>
        </div>
        <el-tabs type="border-card" tab-position="top" @tab-click="handleClick" v-model="tabSel">
            <el-tab-pane label="赠品/换购" name="tab0">
                <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
                    <el-button size="small" type="danger" @click="updateOrAddSave">{{form.freeId==''?'下一步':'保 存'}}</el-button>
                </div>
                <el-form :model="form" label-width="120px" size="small">
                    <el-form-item label="名称" :required="true">
                        <el-input v-model="form.freeName" placeholder="名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="开始日期" :required="true">
                        <el-date-picker
                                v-model="form.beginTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" :required="true">
                        <el-date-picker
                                v-model="form.endTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select :popper-append-to-body="true" v-model="form.status">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="价格" :required="true">
                        <el-input-number v-model="form.freePrice" :min="0" :max="10000" label="价格"></el-input-number>
                        <span style="color: red">价格为0时为赠品，大于0时为换购价格</span>
                    </el-form-item>
                </el-form>

            </el-tab-pane>
            <el-tab-pane label="规则管理" v-if="form.freeId!=''" name="tab1">
                <el-form :inline="true" :model="formInline2" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                    <el-form-item>
                        <el-button type="primary" @click="getList2">查询</el-button>
                        <el-button type="success" @click="handleAdd2">新增</el-button>

                    </el-form-item>
                </el-form>
                <el-table :data="dataList2" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading2">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="freeRuleId" label="标志"></el-table-column>
                    <el-table-column prop="freeRuleTypeName" label="类型"></el-table-column>
                    <el-table-column prop="freeRuleDataName" label="规则"></el-table-column>
                    <el-table-column prop="freeRuleDataExtendName"  label="规则详情"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="160">
                        <template slot-scope="scope">
                            <el-button type="warning " size="mini" @click="deleteData2(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                            background
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="formInline2.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline2.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline2.recordsTotal">
                    </el-pagination>
                </div>
                <el-dialog title="规则管理" :visible.sync="dialogFormVisible2" center append-to-body>
                    <el-form :model="form2" label-width="120px" size="small">
                        <el-form-item label="规则类型" :required="true">
                            <el-select v-model="form2.freeRuleType" @change="onRuleTypeChange">
                                <el-option
                                        v-for="item in getFreeTypeList"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品类型" v-show="showSalesType" :required="true">
                            <el-select v-model="form2.salesType" @change="onSalesTypeChange">
                                <el-option
                                        v-for="item in getSalesTypeList"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单品" v-show="showProduct" :required="true">
                            <el-select v-model="form2.productId" filterable clearable>
                                <el-option
                                        v-for="item in getProductList"
                                        :key="item.proId"
                                        :label="item.proName"
                                        :value="item.proId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="促销" v-show="showPromotion" :required="true">
                            <el-select v-model="form2.promotionId" filterable clearable>
                                <el-option
                                        v-for="item in getPromotionList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="套装" v-show="showGroup" :required="true">
                            <el-select v-model="form2.groupId" filterable clearable>
                                <el-option
                                        v-for="item in getGroupList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="会员权益" v-show="showVip">
                            <el-select v-model="form2.vipId">
                                <el-option
                                        v-for="item in getVipAllList"
                                        :key="item.rightId"
                                        :label="item.rightName"
                                        :value="item.rightId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="城市" v-show="showCity">
                            <el-checkbox-group v-model="form2.citys">
                                <el-checkbox v-for="city in getCityList" :label="city.cityId" :key="city.cityId">{{city.cityName}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="金额" v-show="showAmount" :required="true">
                            <el-input-number v-model="form2.amount" :min="0" :max="10000" label="金额"></el-input-number>
                        </el-form-item>
                        <el-form-item label="用户订单类别" v-show="showOrderNum" :required="true">
                            <el-select v-model="form2.orderType" filterable>
                                <el-option
                                        v-for="item in orderTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优惠券" v-show="showCoupon" :required="true">
                            <el-select v-model="form2.ticketBatchId" filterable>
                                <el-option
                                        v-for="item in getCouponList"
                                        :key="item.ticketBatchId"
                                        :label="item.ticketBatchName+'-'+item.userName"
                                        :value="item.ticketBatchId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="预付卡" v-show="showPrepayCard" :required="true">
                            <el-select v-model="form2.prepayCardId" filterable>
                                <el-option
                                        v-for="item in getPrepayCardList"
                                        :key="item.promotionId"
                                        :label="item.promotionName"
                                        :value="item.promotionId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="活动" v-show="showActive" :required="true">
                            <el-select v-model="form2.activeId">
                                <el-option
                                        v-for="item in getActiveAllList"
                                        :key="item.activeNo"
                                        :label="item.activeName"
                                        :value="item.activeNo">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="品类" v-show="showCategory" :required="true">
                            <el-select v-model="form2.categoryId">
                                <el-option
                                        v-for="item in productCategoryList"
                                        :key="item.categoryId"
                                        :label="item.categoryName"
                                        :value="item.categoryId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                        <el-button type="primary" @click="updateOrAddSave2">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="赠品商品/换购商品" v-if="form.freeId!=''" name="tab2">
                <el-form :inline="true" :model="formInline1" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                    <el-form-item>
                        <el-button type="primary" @click="getList1">查询</el-button>
                        <el-button type="success" @click="handleAdd1">新增</el-button>

                    </el-form-item>
                </el-form>
                <el-table :data="dataList1" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading1">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="freeProductId" label="标志"></el-table-column>
                    <el-table-column prop="productId" label="商品ID"></el-table-column>
                    <el-table-column prop="productTypeName" label="商品类型"></el-table-column>
                    <el-table-column prop="productName" label="商品名称"></el-table-column>
                    <el-table-column prop="productCount"  label="数量"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="160">
                        <template slot-scope="scope">
                            <el-button type="success" size="mini" @click="handleUpdate1(scope.row)">修改</el-button>
                            <el-button type="warning " size="mini" @click="deleteData1(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                            background
                            @size-change="handleSizeChange1"
                            @current-change="handleCurrentChange1"
                            :current-page="formInline1.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline1.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline1.recordsTotal">
                    </el-pagination>
                </div>
                <el-dialog title="商品管理" :visible.sync="dialogFormVisible1" center append-to-body>
                    <el-form :model="form1" label-width="120px" size="small">
                        <el-form-item label="类别" :required="true">
                            <el-select v-model="form1.productType" clearable filterable  placeholder="类别" @change="handlePlatformChange">
                                <el-option v-for="item in itemTypeData"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="指定商品" :required="true">
                            <el-select v-model="form1.productId" filterable clearable width="400px">
                                <el-option
                                        v-for="item in productList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="数量" :required="true">
                            <el-input-number v-model="form1.productCount" :min="1" :max="10000" label="数量"></el-input-number>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                        <el-button type="primary" @click="updateOrAddSave1">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    //定义组件
    import {
        deleteFreeProduct,
        deleteFreeRule,
        getActivePromotionsByActiveType,
        getCityList,
        getConfigSalesTypeList,
        getEnableCashticketListApi,
        getFreeProductList,
        getFreeRuleList,
        getFreeTypeList,
        getGroupListL,
        getItems,
        getProductListL,
        getPromotionList,
        getSalesTypeList,
        getVipAllList,
        getCategoryList,
        getCashRuleItemListApi,
        saveOrUpdateFree,
        saveOrUpdateFreeProduct,
        saveOrUpdateFreeRule,
        getFree,getActiveForOption
    } from "../../api/api";

    export default {
        data() {
            return {
                tabSel:'tab0',
                dataList: [],
                dataList1: [],
                dataList2: [],
                itemTypeData: [],
                getProductList: [],
                productList: [],
                getPromotionList: [],
                getGroupList: [],
                getFreeTypeList: [],
                getSalesTypeList: [],
                getCityList: [],
                getVipAllList: [],
                getCouponList: [],
                getPrepayCardList: [],
                productCategoryList:[],
                getActiveAllList:[],
                orderTypeList:[  {label: '新用户首单', value: '1'},
//                    {label: '套装', value: '2'},
                    ],
                loading1: false,
                loading2: false,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                dialogFormVisible5: false,
                dialogFormVisible6: false,
                showSalesType: false,
                showProduct: false,
                showPromotion: false,
                showGroup: false,
                showVip: false,
                showCity: false,
                showAmount: false,
                showOrderNum:false,
                showCoupon: false,
                showPrepayCard: false,
                statusList: [{value: 1, name: '上线'}, {value: 0, name: '不上线'}],
                showActive:false,
                showCategory:false,
                formInline1: {
                    freeId: this.$route.params.id,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formInline2: {
                    freeId: this.$route.params.id,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form: {
                    freeId:this.$route.params.id,
                    freeName:"",
                    beginTime:"",
                    endTime:"",
                    status:"",
                    freePrice:""
                },
                form1: {
                    freeProductId:"",
                    freeId:this.$route.params.id,
                    productId:"",
                    productName:"",
                    productCount:"",
                    productType:4
                },
                form2: {
                    freeId:this.$route.params.id,
                    freeRuleType:"",
                    productId:"",
                    groupId:"",
                    promotionId:"",
                    salesType:"",
                    citys:[],
                    amount:"",
                    vipId:"",
                    ticketBatchId:"",
                    prepayCardId:"",
                    activeId:"",
                    categoryId:"",
                    orderType:""
                },
            }
        },
        //挂载时候执行
        mounted() {
            getProductListL().then((res) => {
                this.getProductList = res.data.value;
            });
            getPromotionList().then((res) => {
                this.getPromotionList = res.data.value;
            });
            getGroupListL().then((res) => {
                this.getGroupList = res.data.value;
            });
            getFreeTypeList().then((res) => {
                this.getFreeTypeList = res.data.value;
            });
            getSalesTypeList().then((res) => {
                this.getSalesTypeList = res.data.value;
            });
            getCityList().then((res) => {
                this.getCityList = res.data.value;
            });
            getVipAllList().then((res) => {
                this.getVipAllList = res.data.value;
            });
            getEnableCashticketListApi({currentPage: 1, pageSize: 9999,ticketBatchName:''}).then((res) => {
                this.getCouponList = res.data.value.list;
            });
            getActivePromotionsByActiveType({activeType:27}).then((res) => {
                this.getPrepayCardList = res.data.value;
            });
            //产品品类
            getCategoryList({currentPage: 1, pageSize: 9999}).then((res) => {
                this.productCategoryList = res.data.value.list;
            });
            if(this.form.freeId!=''){
                this.initFree();
            }
            getActiveForOption({}).then((res) => {
                this.getActiveAllList = res.data.value;
            })
        },
        methods:{
            handlePlatformChange(data){
                this.form1.productType=data;
                //商品
                getItems({itemType:data}).then((res) => {
                    console.log(res);
                    this.productList=res.data;
                });
            },
            initFree(){
                getFree({freeId: this.form.freeId}).then(res=>{
                    console.log(res)
                    this.form = res.data.value;
                    this.form1.freeId=res.data.value.freeId;
                    this.formInline1.freeId=res.data.value.freeId;
                    this.form2.freeId=res.data.value.freeId;
                    this.formInline2.freeId=res.data.value.freeId;
                    this.getList1();
                    this.getList2();
                })
            },
            handleAdd() {
                this.form.freeId="";
                this.form.freeName="";
                this.form.beginTime="";
                this.form.endTime="";
                this.form.status="";
                this.form.freePrice="";
                this.dialogFormVisible = true;
            },
            updateOrAddSave() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateFree(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        if(this.freeId==''){
                            this.form = res.data.value
                            //this.fullcutId = res.data.value
                            //this.form = res.data.value;
                            this.form1.freeId=res.data.value.freeId;
                            this.formInline1.freeId=res.data.value.freeId;
                            this.form2.freeId=res.data.value.freeId;
                            this.formInline2.freeId=res.data.value.freeId;
                            this.getList1();
                            this.getList2();

                            this.$router.replace({path:'/free/detail/:id',name: 'freeEdit',params:{id:res.data.value}})
                        }
                        this.tabSel = 'tab1';

                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getList1() {
                this.loading1 = true;
                getFreeProductList(this.formInline1).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
//                        this.$message({
//                            showClose: true,
//                            message: '查询成功',
//                            type: 'success'
//                        });
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.dataList1 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.getList1()
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.getList1()
            },
            handleAdd1() {
                this.form1.freeProductId="";
                this.form1.productId="";
                this.form1.productName="";
                this.form1.productCount="";
                this.form1.productType=4;
                this.dialogFormVisible1 = true;

                getConfigSalesTypeList().then((res) => {
                    this.itemTypeData = [];
                    res.data.value.forEach(item => {
                        if (Number(item.id) < 5) {
                            this.itemTypeData.push({id: Number(item.id), name: item.name});
                        }
                        this.handlePlatformChange(this.form1.productType);
                    });
                });
            },
            handleUpdate1(row) {
                this.form1.freeProductId=row.freeProductId;
                this.form1.freeId=row.freeId;
                this.form1.productId=row.productId;
                this.form1.productName=row.productName;
                this.form1.productCount=row.productCount;
                this.form1.productType=row.productType;
                this.dialogFormVisible1 = true;
                this.handlePlatformChange(this.form1.productType);
            },
            updateOrAddSave1() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateFreeProduct(this.form1).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList1();
                        this.dialogFormVisible1 = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteData1(row) {
                this.$confirm('删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteFreeProduct({freeProductId: row.freeProductId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList1();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            handleFreeRule(row){
                //  打开产品
                this.form2.freeId=row.freeId;
                this.formInline2.freeId=row.freeId;
                this.getList2();
                this.dialogFormVisible6 = true;
            },
            getList2() {
                this.loading2 = true;
                getFreeRuleList(this.formInline2).then((res) => {
                    this.loading2 = false;
                    if (res.data.status == 200) {
//                        this.$message({
//                            showClose: true,
//                            message: '查询成功',
//                            type: 'success'
//                        });
                        this.formInline2.recordsTotal = res.data.value.total;
                        this.dataList2 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange2(val) {
                this.formInline2.pageSize = val;
                this.getList2();
            },
            handleCurrentChange2(val) {
                this.formInline2.currentPage = val;
                this.getList2();
            },
            handleAdd2() {
                this.dialogFormVisible2 = true;
            },
            updateOrAddSave2() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateFreeRule(this.form2).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList2();
                        this.dialogFormVisible2 = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteData2(row) {
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteFreeRule({freeRuleId: row.freeRuleId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList2();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            onRuleTypeChange(val){
                this.showAmount= false;
                this.showSalesType= false;
                this.showProduct= false;
                this.showGroup= false;
                this.showPromotion= false;
                this.showCity= false;
                this.showVip= false;
                this.showCoupon= false;
                this.showPrepayCard= false;
                this.showActive= false;
                this.showCategory=false;
                this.showOrderNum=false
                if(val==1){
                    //金额
                    this.showAmount= true;
                    this.consoleShowStatus();
                }else if(val==2){
                    //商品
                    this.showSalesType= true;
                    this.consoleShowStatus();
                }else if(val==3){
                    //城市
                    this.showCity= true;
                    this.consoleShowStatus();
                }else if(val==4){
                    //vip
                    this.showVip= true;
                    this.consoleShowStatus();
                }else if(val==5){
                    //coupon
                    this.showCoupon = true;
                    this.consoleShowStatus();
                }else if(val==6){
                    //prepaycard
                    this.showPrepayCard = true;
                    this.consoleShowStatus();
                }else if(val==7){
                    //active
                    this.showActive = true;
                    this.consoleShowStatus();
                }else if(val==8){
                    //active
                    this.showCategory = true;
                    this.consoleShowStatus();
                }else if(val==9){
                    //active
                    this.showOrderNum = true;
                    this.consoleShowStatus();
                }
            },
            consoleShowStatus(){
                console.log("this.showAmount",this.showAmount);
                console.log("this.showSalesType",this.showSalesType);
                console.log("this.showProduct",this.showProduct);
                console.log("this.showGroup",this.showGroup);
                console.log("this.showPromotion",this.showPromotion);
                console.log("this.showCity",this.showCity);
                console.log("this.showVip",this.showVip);
                console.log("this.showCoupon",this.showCoupon);
                console.log("this.showPrepayCard",this.showPrepayCard);
                console.log("this.showActive",this.showActive);
                console.log("this.showCategory",this.showCategory);
            },
            onSalesTypeChange(val){
                this.showProduct= false;
                this.showPromotion= false;
                this.showGroup= false;
                if(val==4){
                    this.showProduct= true;
                }else if(val==1){
                    this.showPromotion= true;
                }else if(val==2){
                    this.showGroup= true;
                }
            },
            returnHistory(){
                window.history.back()
            },
            handleClick(){
                console.log(this.tabSel)
                if(this.tabSel=='tab1'){

                }
            },
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .full-cut-detail-wrap{
        padding: 10px;
        .header-return{
            margin-bottom: 20px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 10px;
            position: relative;
            h2{
                text-align: center;
                position: absolute;
                left: 50%;
                top:0;
                margin: 0;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/sales/freeEdit.vue